const state = {
  quote: {}
}

export default state



// WEBPACK FOOTER //
// ./src/store/modules/raceQuote/state.js